import { useEffect, useRef, useState } from "react"
import { _HelpDesk, _RequestAdquisitionItem, _single, _Test } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { SelectFunctionalArea } from "../../../../../admin/configuracion/FunctionalArea/SelectFunctionalArea";
import { SelectAdquisitionPlan } from "../../../../../contract/select/SelectAdquisitionPlan";
import { SelectFunctionalID } from "../../../../../admin/configuracion/functionalID/SelectFunctionalID";
import { SelectAdquisitionPlanFunctionalIDByPlan } from "../../../../../contract/select/SelectAdquisitionPlanFunctionalIDByPlan";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { SelectIDLnAssigned } from "../../../../../theme/Component/SelectIDLnAssigned";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { EditorAdquisitionPlanFunctionalIDByPlan } from "./Componentes/EditorAdquisitionPlanFunctionalIDByPlan";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}
interface Props {
    configProcedure: ProcedureFunctions;
}

interface PropsForm {
    JustifyItem: string;
    Amount: number;
    FunctionalIDLnRequest: number;
    IDAdquisitionPlan: number;
    IDAdquisitionPlanFunctionalID: number;
    YearPlan: number;
    IDRequestAdquisitionItem?: number;
    IDProcedureImp?: number;
    AssignTo?: number;
    AreaRequestedName?: string;
}

export const SPAA001 = ({ configProcedure }: Props) => {

    const { _pocessData, _exportMap, _procedure, _pushInfo, _pushProps } = configProcedure;
    const { instance, spin } = useDataBean(_RequestAdquisitionItem)


    const [props, setProps] = useState<any>({});
    const [dataForm, setDataForm] = useState<Partial<PropsForm>>({
        YearPlan: _single.getCurrenYear(),
    })

    useEffect(() => {
        if (_pocessData?.Props) {
            setProps(_pocessData?.Props)
            if (_pocessData?.Props.IDRequestAdquisitionItem) {
                setDataForm({ ...dataForm, ..._pocessData?.Props })
            }
        }

    }, [configProcedure?._pocessData])

    const enviardata = () => {

        if (!dataForm.AssignTo) {
            toast.error("Area funcional no cuenta con responsable asignado");
            return;
        }

        let newData = { ...dataForm, IDEmployee: _single.getAccountID(), State: 100, IDProcedureImp: _procedure?.IDProcedureImp }

        instance.updateRequestAdquisitionItem(newData).then(
            (resp) => {
                console.log(resp)
                if (_pushInfo) {
                    configProcedure?._pushInfo(_single.jsonToBootstrapTable({
                        "Justificación": newData.JustifyItem,
                        "Valor": newData.Amount,
                        "Area Solicitada": newData.AreaRequestedName
                    }));
                }
                if (_exportMap) {
                    configProcedure?._exportMap(newData);
                }
                if (_pushProps) {
                    configProcedure?._pushProps({ ...resp, ...newData });
                }
            }
        ).catch(err => { toast.error("No se pudo realizar la accion"); console.log(err) })
    }

    return (
        <div className="row">
            <div className="col-md-6">
                <label>Area Solicitante</label>
                <SelectIDLnAssigned idSelector={dataForm.FunctionalIDLnRequest} onChange={(e) => { setDataForm({ ...dataForm, FunctionalIDLnRequest: e }) }} label=" " />
            </div>

            <div className="col-md-6">
                <label>Valor de la Necesidad</label>
                <InputMoney _value={dataForm.Amount} onChange={(e) => { setDataForm({ ...dataForm, Amount: e }) }} _label=" " />
            </div>

            <div className="col-md-6">
                <label>Año del Plan de Compras</label>
                <input type="" className="form-control" value={dataForm.YearPlan} onChange={(e) => {
                    const valor = e.target.value ? Number(e.target.value) : null;
                    setDataForm({ ...dataForm, YearPlan: valor })
                }} />
            </div>

            <div className="col-md-6">
                <label>Plan de Compras</label>
                <SelectAdquisitionPlan label=" " idSelector={dataForm.IDAdquisitionPlan} onChange={(e) => { setDataForm({ ...dataForm, IDAdquisitionPlan: e }) }} _year={dataForm.YearPlan} StatePlans={0} />
            </div>

            <div className="col-md-6">
                <label>Area Solictada</label>
                <EditorAdquisitionPlanFunctionalIDByPlan label=" " idPlan={dataForm.IDAdquisitionPlan} IDSelect={dataForm.IDAdquisitionPlanFunctionalID} onChange={(e) => { setDataForm({ ...dataForm, IDAdquisitionPlanFunctionalID: e?.IDAdquisitionPlanFunctionalID, AssignTo: e?.IDAccount, AreaRequestedName: e?.IDLnFunctionalIDName }); }} />
            </div>

            <div className="col-md-12">
                <label>Justificación</label>
                <textarea value={dataForm.JustifyItem} onChange={(e) => { setDataForm({ ...dataForm, JustifyItem: e.target.value }) }} className="form-control" />
            </div>
            <div className="col-md-12">
                <BasicButton spinner icon="" eventClick={enviardata}>Guardar</BasicButton>
            </div>
        </div>
    )
}